<template>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1 v-if="subject">{{ subject.title }}</h1>
        <p>{{ subject.description }}</p>
        <br>
        <p><a href="#" @click.prevent="openEditModal(subject)" class="btn btn-light">Редактировать предмет</a></p>
      </div>
      <div class="col-md-5 offset-md-1">
        <img v-if="variants && subjectClasses" src="/static/images/subjects/subject.png" alt="" class="img-fluid">
        <img v-else src="/static/images/subjects/empty.svg" alt="" class="img-fluid">
      </div>
    </div>
    <hr class="space space-sm">

    <div v-if="subject.isExam">
      <h3>Варианты</h3>
      <br>
      <div class="row" v-if="variants">
        <div class="col-md-5">
          <div class="card mb-3" v-for="variant in orderedVariants" :key="variant.id">
            <div class="card-body p-3">
              <div class="d-flex justify-content-between">
                <p class="large semibold cursor-pointer" v-b-toggle="'variant' + variant.id">{{ variant.title }}</p>
                <p><a href="#" @click.prevent="openEditVariantModal(variant)"><img src="/static/images/icons/edit.svg" alt=""></a></p>
              </div>
              <b-collapse :id="'variant' + variant.id">
              <div v-if="variant.questions">
                <draggable v-model="variant.questions" @change="reorderQuestions(variant)">
                  <transition-group>
                    <p class="semibold truncate" v-for="(question, index) in variant.questions" :key="index+1"><img src="/static/images/icons/burger.svg" alt="">
                      <a href="#" @click.prevent="openEditQuestionModal(variant, question, index)" :class="{ 'text-danger': question.answer.length < 1 }">{{ index + 1 }} {{ question.question }}</a>
                    </p>
                  </transition-group>
                </draggable>
              </div>
              <p><a href="#" class="btn btn-light" @click.prevent="openEditQuestionModal(variant)"><img src="/static/images/icons/plus.svg" alt=""> Добавить вопрос</a></p>
              </b-collapse>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="card sticky">
            <div class="card-body p-3">
              <question-edit ref="questionModal" :subjectSlug="id" :item="editVariant" :editQuestion="editQuestion" :editQuestionIndex="editQuestionIndex" @update="update"></question-edit>
            </div>
          </div>
        </div>
      </div>
      <br>
      <p class="text-center">
        <a href="#" @click.prevent="openEditVariantModal(false)" class="btn btn-light">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          Добавить вариант
        </a>
      </p>
      <hr class="space space-sm">
    </div>

    <div v-else>
      <div class="row" v-if="!variants || !subjectClasses">
        <div class="col-md-12">
          <div class="card py-5">
            <div class="card-body p-3 py-5 text-center">
              <h3>Классов и уроков пока нет</h3>
              <p>Начните наполнение предмета с добавления класса</p>
              <p><a href="#" @click.prevent="openEditSubjectClassModal(false)" class="btn btn-lg btn-light">Добавить класс</a></p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="subjectClasses && subjectClasses.length > 0">
        <br>
        <div v-for="subjectClass in subjectClasses" :key="subjectClass.id">
          <div class="d-flex">
            <h3>{{ subjectClass.title }}</h3>
            <p class="ml-2"><a href="#" @click.prevent="openEditSubjectClassModal(subjectClass)"><img src="/static/images/icons/edit.svg" alt=""></a></p>
          </div>
          <br>

          <div class="row">
            <div class="col-md-6 mb-3" v-for="week in subjectClass.weeks" :key="week.id">
              <div class="card">
                <div class="card-body p-3">
                  <div class="d-flex justify-content-between">
                    <p class="large semibold">{{ week.title }}</p>
                    <p><a href="#" @click.prevent="openEditSubjectClassWeekModal(week, subjectClass)"><img src="/static/images/icons/edit.svg" alt=""></a></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card">
                <div class="card-body p-2">
                  <p class="text-center">
                    <a href="#" @click.prevent="openEditSubjectClassWeekModal(false, subjectClass)" class="btn btn-light">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                      Добавить неделю
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <br>
        <p class="text-center">
          <a href="#" @click.prevent="openEditSubjectClassModal(false)" class="btn bg-lighter">
            Добавить класс
          </a>
        </p>
        <hr class="space space-sm">
      </div>
    </div>

    <subject-add ref="modal" :item="editSubject" @update="update"></subject-add>
    <variant-add ref="variantModal" :subjectSlug="id" :item="editVariant" @update="update"></variant-add>
    <subject-class-add ref="subjectClassModal" :subjectSlug="id" :item="editSubjectClass" @update="update"></subject-class-add>
    <subject-class-week-add ref="subjectClassWeekModal" :subjectClass="editSubjectClass" :subjectSlug="id" :item="editSubjectClassWeek" @update="update"></subject-class-week-add>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import SubjectAdd from './Includes/SubjectAddModal'
import VariantAdd from './Includes/VariantAddModal'
import ClassAddModal from './Includes/ClassAddModal'
import ClassWeekAddModal from './Includes/ClassWeekAddModal'
import QuestionEdit from './Includes/QuestionEditModal'
import { mapState } from 'vuex'

export default {
  name: 'admin-subject',
  props: ['id'],
  components: {
    subjectAdd: SubjectAdd,
    variantAdd: VariantAdd,
    subjectClassAdd: ClassAddModal,
    subjectClassWeekAdd: ClassWeekAddModal,
    questionEdit: QuestionEdit,
    draggable
  },
  data () {
    return {
      editSubject: null,
      editVariant: null,
      editQuestion: null,
      editQuestionIndex: null,
      editSubjectClass: null,
      editSubjectClassWeek: null
    }
  },
  computed: {
    ...mapState({
      subject: state => state.managers.subject,
      variants: state => state.managers.variants,
      subjectClasses: state => state.managers.subjectClasses
    }),
    orderedVariants () {
      return this.variants.sort((a, b) => {
        return a.id - b.id
      })
    }
  },
  methods: {
    openEditModal (item) {
      if (item) {
        this.editSubject = item
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      } else {
        this.editSubject = null
        setTimeout(() => {
          this.$refs.modal.showModal()
        }, 100)
      }
    },
    update () {
      this.$store.dispatch('GET_SUBJECT', this.id)
      this.$refs.modal.hideModal()
    },
    openEditVariantModal (item) {
      if (item) {
        this.editVariant = item
        setTimeout(() => {
          this.$refs.variantModal.showModal()
        }, 100)
      } else {
        this.editVariant = null
        setTimeout(() => {
          this.$refs.variantModal.showModal()
        }, 100)
      }
    },
    openEditSubjectClassModal (item) {
      if (item) {
        this.editSubjectClass = item
        setTimeout(() => {
          this.$refs.subjectClassModal.showModal()
        }, 100)
      } else {
        this.editSubjectClass = null
        setTimeout(() => {
          this.$refs.subjectClassModal.showModal()
        }, 100)
      }
    },
    openEditSubjectClassWeekModal (item, subjectClass) {
      this.editSubjectClass = subjectClass
      if (item) {
        this.editSubjectClassWeek = item
        setTimeout(() => {
          this.$refs.subjectClassWeekModal.showModal()
        }, 100)
      } else {
        this.editSubjectClassWeek = null
        setTimeout(() => {
          this.$refs.subjectClassWeekModal.showModal()
        }, 100)
      }
    },
    openEditQuestionModal (item, question, index) {
      if (item) {
        this.editVariant = item
        this.editQuestion = question
        this.editQuestionIndex = index
      } else {
        this.editVariant = item
        this.editQuestion = null
        this.editQuestionIndex = null
      }
    },
    reorderQuestions (variant) {
      let subjectSlug = this.id
      this.$store.dispatch('UPDATE_SUBJECT_VARIANT', { subjectSlug, variant }).then((response) => {
        this.update()
      })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('GET_SUBJECT', this.id)
    this.$store.dispatch('GET_SUBJECT_VARIANTS', this.id)
    this.$store.dispatch('GET_SUBJECT_CLASSES', this.id)
  }
}
</script>